<fdx-common-core>
    <div class="contentLoading fdx-c-loading-indicator fdx-c-loading-indicator--default fdx-u-mt--20 fdx-u-mb--20">
        <div class="fdx-c-loading-indicator__part"></div>
        <div class="fdx-c-loading-indicator__part"></div>
        <div class="fdx-c-loading-indicator__part"></div>
        <div class="fdx-c-loading-indicator__part"></div>
    </div>
</fdx-common-core>